import { formatCalendarDate } from '../../../common/libs/date';

export function defaultKey() {
  const now = new Date();
  return formatCalendarDate(now);
}



// WEBPACK FOOTER //
// ./client/src/utils/config-keys.js